export const getCurrentDateTime = () => {
  let newDate = new Date().toLocaleString();
  return newDate;
};

export const getDateTimeForKey = (key) => {
  let date = new Date();
  let val =
    key +
    "-" +
    date.getDate() +
    date.getMonth() +
    date.getHours() +
    date.getMinutes() +
    date.getSeconds();
  return val;
};

export const getRunEnd = () => {
  const now = new Date();
  const dateString = `${(now.getUTCDate() + 100).toString().slice(-2)}-${(
    now.getUTCMonth() + 1
  )
    .toString()
    .slice(-2)}-${now.getUTCFullYear()} ${now.getUTCHours()}:${(
    now.getUTCMinutes() + 100
  )
    .toString()
    .slice(-2)}:${(now.getUTCSeconds() + 100).toString().slice(-2)}`;
  return dateString;
};

const DISPLAY_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// "19-06-2026 07:57:11" → "19 Jun 2026, 07:57"  ("—" if empty/invalid)
export const formatDisplayDate = (str) => {
  const ms = parseDateString(str);
  if (!ms) return "—";
  const d = new Date(ms);
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${day} ${DISPLAY_MONTHS[d.getMonth()]} ${d.getFullYear()}, ${hh}:${mm}`;
};

// Parse "DD-MM-YYYY HH:mm:ss" → epoch ms (0 if missing/invalid)
export const parseDateString = (str) => {
  if (!str) return 0;
  try {
    const [datePart, timePart = "00:00:00"] = str.split(" ");
    const [dd, mm, yyyy] = datePart.split("-");
    const ms = new Date(`${yyyy}-${mm}-${dd}T${timePart}`).getTime();
    return Number.isNaN(ms) ? 0 : ms;
  } catch {
    return 0;
  }
};

// Format a millisecond duration → "HH:MM:SS" (drops the hours block under 1h)
export const formatDuration = (ms) => {
  if (!ms || ms < 0) ms = 0;
  const totalSeconds = Math.floor(ms / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

export const getCurrentDateTimeInFormat = () => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, "0");
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const year = currentDate.getFullYear();
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

  return formattedDate;
};
